<template>
  <div id="App">
    <router-view></router-view>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import url('@/css/init.scss');
@import url('@/css/index.scss');
</style>
